import React, { useState, useContext, useEffect } from "react";
import { AutoComplete } from "antd";
import { observer } from "mobx-react";
import CompanyStore from "../store/CompanyStore";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";
import { useCookies } from "react-cookie";
import { decode as base64_decode } from "base-64";
import { useMemo, useRef } from "react";

const CompanyAutocomplete = observer((props) => {
  const companyStore = new CompanyStore();
  const storeContext = useContext(StoreContext);
  const [cookies] = useCookies();
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");

  //console.log(props)

  useEffect(() => {
    if (!props.value) { setInputValue(""); return; }

    // ✅ props.value is an array [{ label, value }]
    if (Array.isArray(props.value) && props.value.length > 0) {
      setInputValue(props.value[0]?.label || "");
    }
    // ✅ props.value is object { label, value }
    else if (typeof props.value === 'object') {
      setInputValue(props.value?.label || "");
    }
    // ✅ props.value is plain string/number
    else {
      setInputValue(props.value || "");
    }

  }, [props.value]);


  const isAdmin =
    Number(JSON.parse(base64_decode(cookies.data)).isadmin) === -1 ||
    Number(JSON.parse(base64_decode(cookies.data)).isadmin) === 3;

  // ✅ Fetch companies as user types
  const debounceTimer = useRef(null);

  const handleSearch = (searchText) => {
    clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(async () => {
      if (!searchText) { setOptions([]); return; }
      const data = await companyStore.getCompanyData(searchText, props.fromAccountList, props.showAll);
      setOptions(data.map(item => ({ value: item.value, label: item.label })));
    }, 500); // ✅ wait 500ms after user stops typing
  };

  // const handleSearch = async (searchText) => {
  //   if (!searchText) {
  //     setOptions([]);
  //     return;
  //   }
  //   const data = await companyStore.getCompanyData(
  //     searchText,
  //     props.fromAccountList,
  //     props.showAll ?? props.showAll
  //   );
  //   // ✅ Map to { value, label } format AutoComplete expects
  //   setOptions(
  //     data.map((item) => ({
  //       value: item.value,       // companyId
  //       label: item.label,       // company name
  //     }))
  //   );
  // };

  // ✅ When user selects an option
  const handleSelect = (value, option) => {
    setInputValue(option.label); // ✅ show label in input (copyable!)
    if (props.onChange) {
      props.onChange({ value: option.value, label: option.label });
    }
  };

  // ✅ When input changes (typing or clearing)
  const handleChange = (val) => {
    setInputValue(val);
    if (!val && props.onClear) {
      props.onClear();
    }
  };

  if (!isAdmin) return null;

  return (
    <AutoComplete
      value={inputValue}               // ✅ real input — fully selectable & copyable
      options={options}
      onSearch={handleSearch}
      onSelect={handleSelect}
      onChange={handleChange}
      placeholder={storeContext.translate("_FLEET_CREATEROUTE_ROUTEADD_COMPANY_")}
      allowClear={props.allowClear}
      style={props.style}
      className={props.className}
    />
  );
});

export default withRouter(CompanyAutocomplete);